import script from "./BaseContactNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseContactNumber.vue?vue&type=script&setup=true&lang=ts"

import "./BaseContactNumber.vue?vue&type=style&index=0&id=bd29de18&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd29de18"]])

export default __exports__